//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PDPScrollToElementMixin from '../../pdp/mixins/PDPScrollToElementMixin';

export default {
  mixins: [PDPScrollToElementMixin],
  props: {
    productUrl: {
      type: Object,
      default: null,
    },
    isSelect: {
      type: Boolean,
    },
    posts: {
      type: Array,
      required: true,
    },
    links: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      postIndex: 0,
      transitioningBetweenPosts: false,
    };
  },
  computed: {
    postUser() {
      return this.posts[this.postIndex].user;
    },
    postHash() {
      return `founder-post-${this.postIndex + 1}`;
    },
  },
  created() {
    const { hash } = this.$route;

    // an: expected format hash: 'founder-post-{number}'
    if (hash?.includes('founder-post-')) {
      const postNumber = Number(hash.charAt(hash.length - 1)) || 1;

      if (postNumber >= 1 && postNumber <= this.posts.length) {
        // an: Set index from hash Post number as index zero-based
        this.postIndex = postNumber - 1;
      }
    }
  },
  methods: {
    clickPost(index) {
      this.postIndex = index;
      this.transitioningBetweenPosts = true;

      // jw: we need to handle this navigation change in the next tick, which should allow the
      //     links card to be repositioned for mobile which will allow distance for scrolling calcs
      //     to be accurate. Technically only needed when scrolling down on mobile, but always doing
      //     this keeps the code cleaner.
      this.$nextTick(() => {
        // jw: push the hash into the history so that reverse navigation can be handled in
        //     PDPSectionTabs.
        window.history.pushState({}, '', `#${this.postHash}`);
        this.$_scrollToElement(document.querySelector(`#${this.postHash}`));

        // an: Once render is done we complete the transition to add an 'active` class
        //     in order to display the post with smoother transition using CSS animation
        this.transitioningBetweenPosts = false;
      });
    },
  },
};
